import { render, staticRenderFns } from "./footerQuestion.vue?vue&type=template&id=2cd5b042"
import script from "./footerQuestion.vue?vue&type=script&lang=js"
export * from "./footerQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports